import { Camera, PenLine } from "lucide-react";

export const ProofOfDelivery = ({ delivery }) => {
  const pod = delivery.pod;
  if (!pod) return null;
  const url = (fid) => `${window.location.origin}/api/deliveries/${delivery.id}/pod/${fid}`;
  return (
    <div className="border border-gray-200 p-5" data-testid="proof-of-delivery">
      <div className="flex items-center gap-2 font-mono text-[11px] tracking-[0.14em] uppercase text-gray-400 mb-3">
        <Camera className="h-3.5 w-3.5" /> Proof of delivery
      </div>
      <a href={url(pod.file_id)} target="_blank" rel="noreferrer">
        <img src={url(pod.file_id)} alt="Proof of delivery" className="w-full max-h-72 object-cover border border-gray-200 hover:opacity-90 transition-opacity" data-testid="pod-image" />
      </a>
      {pod.signature && (
        <div className="mt-4" data-testid="pod-signature">
          <div className="flex items-center gap-2 font-mono text-[11px] tracking-[0.14em] uppercase text-gray-400 mb-2">
            <PenLine className="h-3.5 w-3.5" /> Recipient signature{pod.recipient_name ? ` · ${pod.recipient_name}` : ""}
          </div>
          <img src={url(pod.signature.file_id)} alt="Recipient signature" className="w-full h-24 object-contain border border-gray-200 bg-white" data-testid="pod-signature-image" />
        </div>
      )}
      <div className="font-mono text-[10px] text-gray-400 mt-2">Captured {new Date(pod.uploaded_at).toLocaleString()}</div>
    </div>
  );
};
